<template>
  <div>
    <scout-members
      :member-objects="scoutedMemberObjects"
      :contract-id="Number($route.params.contractId)"
      :job-id="Number($route.params.jobId)"
      display-key="liked"
      data-test="scout-members"
      :count="count"
      :count-limit="countLimit"
      @fetch="fetch"
    />
  </div>
</template>

<script>
import ScoutMembers from '@/components/organisms/ScoutMembers.vue'
import Indicator from '@/lib/indicator'

export default {
  components: {
    ScoutMembers
  },
  data () {
    return {
      likedMembers: [],
      countLimit: 5000,
      count: 0
    }
  },
  computed: {
    scoutedMemberObjects () {
      return this.likedMembers.map((likedMember) => {
        return {
          id: likedMember.id,
          member: likedMember
        }
      })
    }
  },
  watch: {
    $route: {
      handler () {
        this.fetch()
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch (page = 1) {
      Indicator.emitShow()
      this.fetchLikedCount().then(response => {
        this.$set(this, 'count', response.data)
        this.fetchLikedMembers(page)
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    fetchLikedMembers (page = 1) {
      this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/likes/pages/${page}`)
        .then(response => {
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (likedMembers) {
      this.$set(this, 'likedMembers', likedMembers)
    },
    fetchLikedCount () {
      return this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/likes/_count`)
    }
  }
}
</script>
